import BrandLogoImage, {
  type BrandLogoVariant,
} from '@/components/BrandLogoImage';
import { useSiderCollapse } from '@/hooks/useSiderCollapse';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React from 'react';

export type LogoVariant = 'sider' | 'header';

export type LogoProps = {
  collapsed?: boolean;
  variant?: LogoVariant;
};

const Logo: React.FC<LogoProps> = ({
  collapsed: collapsedProp,
  variant = 'sider',
}) => {
  const { collapsed } = useSiderCollapse();
  const effectiveCollapsed = collapsedProp ?? collapsed;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const showTagline =
    variant !== 'header' && (isMobile ? !collapsed : !effectiveCollapsed);

  const getLogoVariant = (): BrandLogoVariant => {
    if (isMobile) {
      return 'compact';
    }
    return effectiveCollapsed ? 'icon' : 'compact';
  };

  const logoClassNames = [
    'sidebar-logo',
    effectiveCollapsed ? 'collapsed' : '',
    isMobile ? 'mobile' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={logoClassNames}>
      <div>
        <BrandLogoImage
          alt="Southbay"
          variant={getLogoVariant()}
          sizes={effectiveCollapsed ? '64px' : '220px'}
          style={{
            height: isMobile ? 42 : 56,
            maxWidth: '100%',
            objectFit: 'contain',
          }}
        />
      </div>
      {showTagline && <div className="tagline">Descuento de Empleados</div>}
    </div>
  );
};

export default Logo;
